import { useEffect, useState } from "react";
import { useSession } from "../session";
export function CatalogSync() {
  const { client } = useSession();
  const [state, setState] = useState<{ at: string | null; paused: boolean; failed: boolean } | null>(null);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    let alive = true,
      last = 0;
    const tick = () => {
      if (document.visibilityState === "hidden") return;
      setNow(Date.now());
      if (Date.now() - last < 60000) return;
      last = Date.now();
      client.call("catalog.syncStatus").then(
        (r) => {
          if (alive) setState({ at: r.lastSuccessAt, paused: !!r.metadataPausedAt, failed: false });
        },
        () => {
          if (alive) setState({ at: null, paused: false, failed: true });
        },
      );
    };
    tick();
    const timer = setInterval(tick, 15000);
    document.addEventListener("visibilitychange", tick);
    return () => {
      alive = false;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", tick);
    };
  }, [client]);
  return (
    <span className="note" role="status" title={state?.at ? new Date(state.at).toLocaleString() : undefined}>
      {!state
        ? "수집 상태 확인 중"
        : state.failed
          ? "수집 상태를 불러오지 못했습니다"
          : `${state.paused ? "상세정보 수집 중단 · " : ""}${
              state.at
                ? `목록 확인 ${Math.max(0, Math.floor((now - Date.parse(state.at)) / 60000))}분 전`
                : "목록 확인 기록 없음"
            }`}
    </span>
  );
}
